import React, { useCallback } from 'react';
import { useAsyncValue, useRevalidator } from 'react-router-dom';

// Components
import { AddBudgetCategoryForm } from '../../../../components/forms/AddBudgetCategoryForm';
import { BudgetCategoriesManagementTable } from '../../../../components/display/tables/formTables/managementTables/BudgetCategoriesManagementTable';

// Types
import { BudgetCategoryManagementLoader } from './types';
import { BudgetCategoryManagement } from '../../../../components/forms/AddBudgetCategoryForm/types';

// Styles
import { Container, BudgetCategoryManagementSection } from './styles';

// Constants
import { formBudgetCategoryManagementNaming } from '../../../../components/forms/AddBudgetCategoryForm/constants';

// GQL
import { client } from '../../../../gql/client';
import { CREATE_BUDGET_CATEGORY } from '../../../../gql/mutations/budget/budgetCategories';

export default function BudgetCategoriesManagementPage(): JSX.Element {
  const loaderData = useAsyncValue() as BudgetCategoryManagementLoader;
  const revalidator = useRevalidator();

  const allCategoryCodes = [
    ...loaderData.activeCategories,
    ...loaderData.inactiveCategories,
  ].map((category) => category.code);

  const onReFetchData = useCallback(() => {
    revalidator.revalidate();
  }, []);

  const onFormSubmit = async (data: BudgetCategoryManagement) => {
    if (allCategoryCodes.some((code) => code === data.code)) {
      return 'El código de categoría ya existe';
    }

    try {
      await client.mutate({
        mutation: CREATE_BUDGET_CATEGORY,
        variables: {
          input: {
            code: data.code,
            name: data.name,
            color: data.color,
          },
        },
      });

      // Revalidar datos después de crear
      onReFetchData();
    } catch (error) {
      return 'Error al crear la categoría presupuestaria';
    }
  };

  return (
    <Container>
      <BudgetCategoryManagementSection>
        <AddBudgetCategoryForm
          initialData={loaderData.cacheData}
          onFormSubmit={onFormSubmit}
          namingPersistForm={
            formBudgetCategoryManagementNaming.NEW_BUDGET_CATEGORY_MANAGEMENT_FORM
          }
        />
      </BudgetCategoryManagementSection>

      <BudgetCategoryManagementSection>
        <BudgetCategoriesManagementTable
          data={{
            activeCategories: loaderData.activeCategories as any,
            inactiveCategories: loaderData.inactiveCategories as any,
          }}
        />
      </BudgetCategoryManagementSection>
    </Container>
  );
}
